.horizontal-overflow {
  display: flow-root;
}

.horizontal-overflow__content {
  margin: calc(var(--rc-theme-spacing-xxs) * -1);
  padding: var(--rc-theme-spacing-xxs);
  overflow-x: auto;
}
